import { PaymentOffsetInterface } from "../PaymentOffsetInterface";
import { PaymentOffset } from "../PaymentOffset";
import Translator from "../../../../../Translation/Translator";

class Plus1Day extends PaymentOffset implements PaymentOffsetInterface  {

  public static value: number = 1;

  public getName(): string {
    return Translator.trans("payment-offset-plus-1-day");
  }

}

export { Plus1Day }
